import { Flex, Box, Text, Collapse } from '@chakra-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import ChooseAudience from './ChooseAudience'
import TaskTypeSelection from './TaskTypeSelection'
import { TimeFramePreview } from './TimeFramePreview'
import { FormContext, useForm } from 'react-hook-form'
import { StepType, TaskAudience, useFormStepContext } from '../../FormStepContext'
import { IndividualResultsSwitch } from './IndividualResultsSwitch'
import dayjs from 'dayjs'
import { SchedulePushSwitch } from './SchedulePushSwitch'
import { Minus, Plus } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { DEFAULT_ALLOWED_OVERDUE_DAYS } from '../../utils'

const TaskSettingStep = () => {
  const { setCurrentFormSubmit, updateFormData, formData, submitAllForms } = useFormStepContext()
  const fromTsFormContext = formData[StepType.TIME_FRAME_SELECTION]?.from_ts
  const deadlineFormContext = formData[StepType.TIME_FRAME_SELECTION]?.deadline
  const allowedOverdueDaysFormContext = formData[StepType.TIME_FRAME_SELECTION]?.allowed_overdue_days
  const t_advancedOptions = useLocaleText('advanced_options')

  const defaultValues = formData[StepType.TASK_SETTINGS] || {
    audience: {
      groups: [],
      users: [],
      tags: [],
    },
    view: 4,
    is_individual_results: false,
    send_schedule_push: true,
    from_ts: fromTsFormContext ? fromTsFormContext : dayjs().toISOString(),
    deadline: deadlineFormContext ? deadlineFormContext : dayjs(dayjs()).add(8, 'hour').toISOString(),
    allowed_overdue_days: allowedOverdueDaysFormContext ? allowedOverdueDaysFormContext : DEFAULT_ALLOWED_OVERDUE_DAYS,
  }
  const [showAdvanced, setShowAdvanced] = useState(true)

  const taskSettings = formData[StepType.TASK_SETTINGS]
  if (taskSettings && taskSettings.send_schedule_push === undefined) {
    defaultValues.send_schedule_push = true
  }

  const methods = useForm({
    defaultValues,
  })

  const { handleSubmit, getValues } = methods

  const currentValues = getValues() as {
    audience: TaskAudience
    view: number | null
    is_individual_results: boolean
    send_schedule_push: boolean
    from_ts: string
    deadline: string
    allowed_overdue_days: number
  }

  useEffect(() => {
    setCurrentFormSubmit(() =>
      handleSubmit((data) => {
        updateFormData(StepType.TASK_SETTINGS, data)
        submitAllForms()
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const prevValuesRef = useRef<any>()
  useEffect(() => {
    const values = currentValues
    if (JSON.stringify(values) !== JSON.stringify(prevValuesRef.current)) {
      updateFormData(StepType.TASK_SETTINGS, values)
      prevValuesRef.current = values
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [methods, updateFormData])

  return (
    <FormContext {...methods}>
      <Flex flexDir="column" style={{ rowGap: '40px' }}>
        <ChooseAudience />
        <TaskTypeSelection />
        <TimeFramePreview />
        <Box mt={2}>
          <Flex alignItems="center" cursor="pointer" onClick={() => setShowAdvanced((v) => !v)}>
            <Flex alignItems="center" style={{ columnGap: '10px' }}>
              {showAdvanced ? <Minus size={16} /> : <Plus size={16} />}
              <Text fontWeight="bold" fontSize="16px">
                {t_advancedOptions}
              </Text>
            </Flex>
          </Flex>
          <Collapse isOpen={showAdvanced} animateOpacity>
            <Box mt={4} px={6} borderRadius="10px" bg="#f7f7f7">
              <Flex flexDir="column" style={{ rowGap: '24px' }}>
                <IndividualResultsSwitch />
                <SchedulePushSwitch />
              </Flex>
            </Box>
          </Collapse>
        </Box>
      </Flex>
    </FormContext>
  )
}

export default TaskSettingStep
